<section class="clinic o-page">
	<div
		class="c-page-heading o-page__heading"
		role="presentation"
	>
		<h1 data-quat="value_vetClinicHeading">
			<!-- FIXME: Update to use new param --> Add a Vet Clinic for {{ petName$ | async }}
		</h1>
		<p class="c-page-heading clinic__instructions">Please add vets that {{ petName$ | async }} has seen in the last
			12 months. <span class="clinic__tooltip">
				<span
					class="clinic__tooltip-trigger"
					aria-describedby="addVetAdditionalInfo"
				> Read More About This</span>
				<span
					class="clinic__tooltip-container"
					role="tooltip"
					id="addVetAdditionalInfo"
				>
					<span class="clinic__tooltip-content m--first-paragraph"> We require your pet's veterinary records
						for 12 months prior to the start date of your policy through the end of the illness waiting
						period.</span> For puppies, kittens, or newly adopted pets, we require records from the time
					they entered your care if it's less than 12 months. </span>
			</span>
		</p>
	</div>
	<form
		[formGroup]="vetClinicForm"
		class="clinic__form o-page__content"
	>
		<div
			role="presentation"
			class="c-input-group"
		>
			<label
				for="zipCode"
				class="c-input-group__label"
				data-quat="label_zipCode"
			>Enter vet clinic zip code</label>
			<div
				role="presentation"
				class="c-input-group__input-wrapper clinic__input-zip"
			>
				<input
					#zipInputEl
					formControlName="zipCode"
					mvPreventAlpha
					type="text"
					inputmode="numeric"
					placeholder="44444"
					name="zipCode"
					id="zipCode"
					[ngClass]="{'is--invalid': invalidZipCode}"
					class="c-input-group__input"
					minlength="5"
					maxlength="5"
					data-quat="input_zipCode"
				>
				<svg
					*ngIf="invalidZipCode"
					aria-hidden="true"
					class="clinic__input-error-icon"
					viewBox="0 0 24 24"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 15v-2h2v2h-2zm0-10v6h2V7h-2z"
						fill="#CC413D"
					/>
				</svg>
				<button
					*ngIf="!clinicInputHidden"
					role="presentation"
					class="clinic__input-clear-icon"
					aria-label="Clear Zip Code Value"
					(click)="stepBack()"
				>
					<svg
						aria-hidden="true"
						viewBox="0 0 56 56"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<rect
							width="23.759"
							height="2.64"
							rx="1"
							transform="rotate(-45 52.145 -4.8)"
							fill="#333"
						/>
						<rect
							width="23.759"
							height="2.64"
							rx="1"
							transform="rotate(45 -12.266 34.12)"
							fill="#333"
						/>
					</svg>
				</button>
				<mat-error
					*ngIf="invalidZipCode"
					class="clinic__error"
				>Invalid zip code</mat-error>
			</div>
		</div>
		<div
			[hidden]="clinicInputHidden"
			role="presentation"
			class="c-input-group clinic__group-clinic"
		>
			<label
				for="clinic"
				class="c-input-group__label"
				data-quat="label_vetClinic"
			>Search for your vet clinic</label>
			<div
				role="presentation"
				class="c-input-group__input-wrapper"
			>
				<div
					role="presentation"
					class="clinic__input-clinic-icon"
				>
					<svg
						aria-hidden="true"
						viewBox="0 0 49 49"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M14.595 22.385c0-4.48 3.68-8.16 8.16-8.16s8.16 3.68 8.16 8.16-3.68 8.16-8.16 8.16-8.16-3.68-8.16-8.16zm-1.84 0c0 5.52 4.48 10 10 10 2.4 0 4.604-.847 6.328-2.258l5.965 5.965a1 1 0 0 0 1.414-1.414l-5.965-5.965a9.957 9.957 0 0 0 2.258-6.328c0-5.52-4.48-10-10-10s-10 4.48-10 10z"
							fill="#333"
						/>
					</svg>
				</div>
				<input
					#clinicInputEl
					formControlName="clinic"
					[matAutocomplete]="clinicList"
					placeholder="Begin typing address or vet name"
					type="text"
					name="clinic"
					id="clinic"
					class="c-input-group__input clinic__input-clinic"
					data-quat="input_vetClinic"
				>
				<mat-autocomplete
					#clinicList="matAutocomplete"
					[displayWith]="optionDisplayValue"
					[autoActiveFirstOption]="true"
					(optionSelected)="handleSelection($event)"
				>
					<mat-option
						*ngFor="let item of filteredOptions$ | async; let i = index"
						[value]="item"
						[attr.data-quat]="'input_vetClinicOption' + i"
					>
						<span
							class="clinic__list-option m--name"
							[innerHTML]="item.accountName | matcher: matchValue"
						></span>
						<span
							class="clinic__list-option m--address"
							[innerHTML]="item.fullAddress | matcher: matchValue"
						></span>
					</mat-option>
					<mat-option
						*ngIf="!(filteredOptions$ | async)?.length"
						[value]="'notListed'"
						data-quat="input_vetClinicOptionNotFound"
					>
						<span class="clinic__list-option m--no-result">
							<strong>No Results</strong> - <em>Check the zip code or spelling</em>
						</span>
					</mat-option>
				</mat-autocomplete>
			</div>
			<div
				class="clinic__link-wrapper"
				role="presentation"
			>
				<span
					role="button"
					tabindex="0"
					id="addVetPopover"
					class="c-link clinic__link"
					(click)="showAddVetPopover()"
				> Can't find vet clinic? </span>
				<div
					aria-labelledby="addVetPopover"
					class="c-popover clinic__link-popover"
					[ngClass]="{ 'is--visible': popoverVisible }"
				>
					<p>
						<strong class="clinic__link-heading">Check Zip Code</strong> Make sure the zip code above
						matches your vet clinic's address &mdash; we use that to search our database.
					</p>
					<p>
						<strong class="clinic__link-heading">Still can't find your vet?</strong> Don't worry, we can add
						them to our system: <br />
						<a
							class="c-link"
							(click)="handleAddNewVet($event)"
						>Add Your Vet Clinic's Address</a>
					</p>
				</div>
			</div>
		</div>
		<button
			[disabled]="vetClinicForm.invalid"
			class="c-cta clinic__cta"
			type="button"
			data-quat="action_nextStepButton"
			(click)="nextStep()"
		> Next </button>
	</form>
	<section class="c-workflow-actions o-page__actions">
		<span aria-hidden="true"></span>
		<mv-cancel-button
			class="c-workflow-actions__item m--end"
			(click)="cancel()"
		></mv-cancel-button>
	</section>
</section>